import { getCorpOptions } from '@/api/corp'
const state = {
  options: null
}

const mutations = {
  CHANGE_OPTIONS: (state, data) => {
    state.options = data
  }
}

const actions = {
  async setOptions({ commit }) {
    const res = await getCorpOptions()
    commit('CHANGE_OPTIONS', res.data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
